export const SW_INIT = "SW_INIT"
export const SW_UPDATE  = "SW_UPDATE"
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR"
export const GET_RESTAURANT_INFO = "GET_RESTAURANT_INFO"
export const GET_RESTAURANT_MENU_DATA = "GET_RESTAURANT_MENU_DATA"
export const GET_RESTAURANT_MENU_OFFER = "GET_RESTAURANT_MENU_OFFER"
export const GET_RESTAURANT_OPENING_TIME = "GET_RESTAURANT_OPENING_TIME"
export const GET_RESTAURANT_ACTIVITE = "GET_RESTAURANT_ACTIVITE"
export const ENABLE_LOADING = "ENABLE_LOADING"
export const DISABLE_LOADING = "DISABLE_LOADING"